import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import StorefrontIcon from '@mui/icons-material/Storefront';
import HomeIcon from '@mui/icons-material/Home';
import PageShell from '../components/PageShell';
import AuthCard from '../components/AuthCard';
import request from '../api';

function StoreLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        setBusy(true);
        try {
            const data = await request('/store/login', { method: 'POST', body: { username, password } });
            localStorage.setItem('storeToken', data.token);
            localStorage.setItem('storeName', data.store.name);
            navigate('/store/dashboard');
        } catch (err) {
            setError(err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <PageShell
            title="Portal de Tiendas"
            nav={<Button component={RouterLink} to="/" color="inherit" startIcon={<HomeIcon />}>Volver al Inicio</Button>}
            maxWidth="sm"
        >
            <AuthCard sx={{ textAlign: 'center' }}>
                <StorefrontIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                <Box component="form" onSubmit={submit}>
                    <Stack spacing={2}>
                        <TextField
                            label="Usuario de la Tienda"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            fullWidth
                            required
                            autoFocus
                        />
                        <TextField
                            label="Contraseña"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            fullWidth
                            required
                        />
                        <Button type="submit" variant="contained" size="large" disabled={busy} fullWidth>
                            Iniciar Sesión
                        </Button>
                        {error && <Alert severity="error">{error}</Alert>}
                        <Link component={RouterLink} to="/store/forgot-password" variant="body2">
                            ¿Olvidaste tu contraseña?
                        </Link>
                    </Stack>
                </Box>
                <Typography variant="body2" sx={{ mt: 3 }}>
                    ¿No tienes cuenta?{' '}
                    <Link component={RouterLink} to="/store/register">
                        Regístra tu tienda
                    </Link>
                </Typography>
            </AuthCard>
        </PageShell>
    );
}

export default StoreLogin;
